import {DesignerVersion} from '@mintdata-wsp/common/state/ui/visualDesigner/DesignState';
import {IMigration} from '@mintdata-wsp/wsp/controllers/visualDesigner/designState/DesignMigrationController';
import {Assert} from '@mintdata/mint-kit/impl/util/Assert';

const MIGRATED_VERSION:DesignerVersion = 8;

export const migration_7_8:IMigration = {
    from: MIGRATED_VERSION - 1,
    to: MIGRATED_VERSION,
    migrate: (designState:any) =>
    {
        Assert.yes(designState.designerVersion === MIGRATED_VERSION - 1);

        console.log(`migration ${MIGRATED_VERSION - 1}->${MIGRATED_VERSION} designState`, designState);

        if( designState.spreadsheets && designState.spreadsheets.workbooks )
        {
            Object.values(designState.spreadsheets.workbooks).forEach((workbook:any) =>
            {
                Object.values(workbook.view.meshStates).forEach((meshState:any) =>
                {
                    Object.values(meshState.cellSettings).forEach((cellSetting:any) =>
                    {
                        if( cellSetting.font && cellSetting.font.weight && cellSetting.font.weight.value )
                        {
                            if( cellSetting.font.weight.value === 'Bold' )
                            {
                                cellSetting.textBold = true;
                            }
                            delete cellSetting.font;
                        }
                        if( cellSetting.isValueMasked === false )
                        {
                            delete cellSetting.isValueMasked;
                        }
                        // TODO: check empty settings
                        // if( !cellSetting.textBold && !cellSetting.isValueMasked )
                        // {
                        //     delete meshState.cellSettings[cellSetting.id];
                        // }
                    });
                });
            });

        }

        designState.designerVersion = MIGRATED_VERSION;

        return designState;
    }
};
